import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import SelectField from '../../../components/SelectField';
import generateKey from '../../../utils/generateKey';
import ColumnTypes from '../../../types/ColumnTypes';
import Tag from './Tag';

var DatabaseSelectField =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(DatabaseSelectField, _React$PureComponent);

  function DatabaseSelectField() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DatabaseSelectField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DatabaseSelectField)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "addSelectOption", function (query) {
      var _this$props = _this.props,
          recordKey = _this$props.record.key,
          columnKey = _this$props.column.key,
          database = _this$props.database;
      var label = query;
      var option = {
        key: generateKey(),
        label: label,
        color: '#F5F5F7'
      };
      database.updateSelectOption(columnKey, option).addSelectOptionToField(recordKey, columnKey, option.key);
    });

    _defineProperty(_assertThisInitialized(_this), "onNewCellItem", function (option, value) {
      var _this$props2 = _this.props,
          recordKey = _this$props2.record.key,
          _this$props2$column = _this$props2.column,
          columnKey = _this$props2$column.key,
          type = _this$props2$column.type,
          database = _this$props2.database;

      if (option.type === 'create') {
        _this.addSelectOption(value);
      } else {
        database.addSelectOptionToField(recordKey, columnKey, option.data.key);
      }

      if (type !== ColumnTypes.MULTI_SELECT) {
        database.activate(recordKey, columnKey);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onRemoveCellItem", function (tag) {
      var _this$props3 = _this.props,
          recordKey = _this$props3.record.key,
          columnKey = _this$props3.column.key,
          database = _this$props3.database;
      database.removeSelectOptionFromField(recordKey, columnKey, tag);
    });

    _defineProperty(_assertThisInitialized(_this), "onEmpty", function () {
      var _this$props4 = _this.props,
          recordKey = _this$props4.record.key,
          columnKey = _this$props4.column.key,
          database = _this$props4.database;
      database.emptySelectField(recordKey, columnKey);
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrentOptions", function () {
      var _this$props5 = _this.props,
          recordKey = _this$props5.record.key,
          columnKey = _this$props5.column.key,
          database = _this$props5.database;
      return database.mapFieldSelectOptions(recordKey, columnKey);
    });

    _defineProperty(_assertThisInitialized(_this), "getOptionsFromQuery", function (query) {
      var inputValue = query.toLowerCase().normalize('NFD');
      var _this$props6 = _this.props,
          recordKey = _this$props6.record.key,
          columnKey = _this$props6.column.key,
          database = _this$props6.database;
      var selectOptions = Object.values(database.getColumnSelectOptions(columnKey));
      var fieldOptions = database.getFieldSelectOptionsKeys(recordKey, columnKey);
      var options = [];
      options = options.concat(selectOptions // Filter out already selected options
      .filter(function (_ref) {
        var key = _ref.key;
        return !fieldOptions.includes(key);
      }) // Only keep matching entries
      .filter(function (_ref2) {
        var label = _ref2.label;
        return label.toLowerCase().normalize('NFD').indexOf(inputValue) >= 0;
      }).map(function (option) {
        return {
          type: 'option',
          data: option
        };
      }));

      if (query.length > 0) {
        options.push({
          type: 'create'
        });
      } // 2019-08-13: Product needs to settle on this
      // if (this.state.value.length === 0 && fieldOptions.length > 0) {
      //   options.push({ type: 'empty' })
      // }


      return Promise.resolve(options);
    });

    _defineProperty(_assertThisInitialized(_this), "renderListItem", function (option) {
      return {
        wrapperProps: {
          key: option.key
        },
        child: React.createElement(Tag, {
          option: option,
          isActive: _this.props.isActive,
          onRemove: function onRemove(event) {
            event.stopPropagation();

            _this.onRemoveTag(option.key);
          }
        })
      };
    });

    _defineProperty(_assertThisInitialized(_this), "renderCellItem", function (option, index, value) {
      switch (option.type) {
        case 'option':
          return {
            wrapperProps: {
              key: option.data.key,
              className: 'shade-05 padding-small'
            },
            child: React.createElement(Tag, {
              option: option.data,
              preventRemoval: true
            })
          };

        case 'create':
          return {
            wrapperProps: {
              key: 'create',
              className: 'shade-30  padding-small'
            },
            child: React.createElement(React.Fragment, null, ' ', ' + ', "create new ", React.createElement(Tag, {
              option: {
                label: value
              }
            }))
          };

        case 'empty':
          return {
            wrapperProps: {
              key: 'empty',
              className: 'shade-30  padding-small',
              onClick: _this.onEmpty
            },
            child: 'leave empty'
          };

        default:
          return false;
      }
    });

    return _this;
  }

  _createClass(DatabaseSelectField, [{
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          attributes = _this$props7.attributes,
          isFocused = _this$props7.isFocused,
          database = _this$props7.database,
          store = _this$props7.store,
          column = _this$props7.column,
          record = _this$props7.record,
          isActive = _this$props7.isActive;
      return React.createElement(SelectField, Object.assign({}, attributes, {
        tooltipMessage: column.type === ColumnTypes.MULTI_SELECT ? 'Add tags' : 'Add tag',
        isFocused: isFocused,
        isActive: isActive,
        multiSelect: column.type === ColumnTypes.MULTI_SELECT,
        listItems: this.getCurrentOptions(),
        renderListItem: this.renderListItem,
        getCellItems: this.getOptionsFromQuery,
        onNewCellItem: this.onNewCellItem,
        onRemoveCellItem: this.onRemoveCellItem,
        renderCellItem: this.renderCellItem,
        database: database,
        column: column,
        record: record,
        store: store
      }));
    }
  }]);

  return DatabaseSelectField;
}(React.PureComponent);

export { DatabaseSelectField as default };